/*
 * Built with Common Launchpad 2.0.3
 */

import $ from 'jquery';

class MainServiceLine {
    constructor() {
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $('.links-show-more').on('click', () => {
            if ($('.links-container').hasClass('active')) {
                $('.links-container').removeClass('active');
                 $('.links-show-more').text('Show more');                
            } else {
                $('.links-container').addClass('active');
                 $('.links-show-more').text('Hide');
            }
        });
    }
}

export default MainServiceLine;

$(() => {
	const mainServiceLine = new MainServiceLine();
	mainServiceLine.init();
});